import { convertToSupportedLang } from '@infl-ts/util-date';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import CircleIcon from '@mui/icons-material/Circle';
import { Box, Typography } from '@mui/material';
import { intlFormat, parseISO } from 'date-fns';
import { absurd } from 'fp-ts/function';
import { useTranslation } from 'react-i18next';
import { SocialAuthButton } from '../../social-auth-button';
import { connectStatus } from './common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var StatusIcon = function StatusIcon(_ref) {
  var sx = _ref.sx;
  return /*#__PURE__*/_jsx(CircleIcon, {
    sx: mergeSxProps({
      width: 8,
      height: 8,
      mr: 0.5
    }, sx),
    "data-element": "CircleIcon",
    "data-component": "StatusIcon",
    "data-source-file": "status.tsx"
  });
};

var Status = function Status(_ref2) {
  var social = _ref2.social,
      inColumnView = _ref2.inColumnView;
  var status = connectStatus(social);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  if (status === 'Connected') {
    return social.__typename === 'Linkedin' && social.expiresAt ? /*#__PURE__*/_jsxs(Box, {
      sx: {
        width: inColumnView ? 1 : '30%',
        mr: 2
      },
      children: [/*#__PURE__*/_jsx(StatusIcon, {
        sx: {
          color: function color(t) {
            return t.palette.warning.main;
          }
        }
      }), /*#__PURE__*/_jsxs(Typography, {
        variant: "caption",
        sx: {
          mt: 0.5
        },
        children: [t('Connection expiring on {{date}}', {
          date: intlFormat(parseISO(social.expiresAt), {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          }, {
            locale: convertToSupportedLang(i18n.language)
          })
        }), /*#__PURE__*/_jsx(SocialAuthButton, {
          isLink: true,
          sx: {
            cursor: 'pointer',
            fontWeight: 'bold',
            p: 0,
            display: 'inline'
          },
          text: t('Reset'),
          authUrl: social.authUrl,
          variant: "text"
        })]
      })]
    }) : /*#__PURE__*/_jsxs(Box, {
      sx: {
        width: inColumnView ? 1 : '35%',
        mr: 2
      },
      children: [/*#__PURE__*/_jsx(StatusIcon, {
        sx: {
          color: function color(t) {
            return t.palette.success.main;
          }
        }
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        sx: {
          mt: 0.5
        },
        children: t('Connected')
      })]
    });
  }

  if (status === 'Expired') {
    return /*#__PURE__*/_jsxs(Box, {
      sx: {
        width: inColumnView ? 1 : '35%',
        mr: 2,
        display: 'flex',
        alignItems: 'center'
      },
      children: [/*#__PURE__*/_jsx(StatusIcon, {
        sx: {
          color: function color(t) {
            return t.palette.error.main;
          }
        }
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        sx: {
          mt: 0.5
        },
        children: t('Connection expired')
      }), /*#__PURE__*/_jsx(SocialAuthButton, {
        isLink: true,
        sx: {
          cursor: 'pointer',
          fontWeight: 'bold',
          p: 0,
          display: 'inline'
        },
        authUrl: social.authUrl,
        text: t('Reconnect')
      })]
    });
  }

  if (status === 'Disconnected') return null;
  return absurd(status);
};

export default Status;